/**************************************************
 * Nombre:       Detalle_Producto_Match
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useEffect, useRef, useState} from "react";
import uno from '../../../Recursos/vista_uno.png'
import dos from '../../../Recursos/vista_dos.png'
import tres from '../../../Recursos/vista_tres.png'
import Zoom from "react-medium-image-zoom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Detalle_Producto_Match = ({producto, setArrProductos}) => {
    const {sCell} = useResponsive()
    const refe = useRef(null)
    const [fotos, setFotos] = useState([])


    const filtrarFotos = (fots, id) => {


        let arr = fots.filter(foto => Array.isArray(foto.productos) &&
            foto.productos.some(prod => prod.id === id))


        // console.log(arr)
        let fotss = []
        for (let i = 0; i < arr.length; i++) {
            fotss.push(...arr[i].imgs)
        }

        // console.log(fotss)
        setFotos(fotss)
        filtrarProductos(arr, id)


    }

    const filtrarProductos = (fots, id) => {


        const productos = [];

        fots.forEach(item => {
            if (Array.isArray(item.productos)) {
                productos.push(...item.productos);
            }
        });


        let set = new Set(productos)
        let arrSet = [...set]

        let arr = arrSet.filter(producto => producto.id !== id);

        setArrProductos(arr)


    }

    useEffect(() => {

        if (producto && producto.id) {

            let w = [where('coleccion', '==', producto.coleccion)]
            console.log('producto', producto)
            obtenerColWheres({col: 'fotos', wheres: w}).then((dox) => {
                console.log('fotos', dox)
                if (dox.res) {
                    filtrarFotos(dox.data, producto.id)
                }
            })


        }


    }, [producto])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 7}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: theme.palette.primary.main}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{px: 0, justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{fontSize: sCell ? 18 : 30, fontWeight: 400}}>Haz</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{mt: -1, justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontSize: sCell ? 32 : 60,
                                    fontWeight: 600,
                                    fontFamily: 'MD Serif Display',
                                    lineHeight: 1.1
                                }}>MATCH</Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 5}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-end', px: sCell ? 1 : 0, mt: sCell ? 1 : 0}}>
                    <Typography
                        sx={{
                            fontSize: sCell ? 14 : 18,
                            fontWeight: 400,
                            color: theme.palette.primary.main,
                            lineHeight: 1.3,
                            textAlign: sCell ? 'center' : 'right'
                        }}>
                       </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 8}}>

                    {fotos.length > 5 ?

                        <Splide
                            ref={refe}
                            aria-label="My Favorite Images" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 1500,
                                rewind: true,
                                perPage: sCell ? 2 : 4,
                                arrows: true,
                                perMove: 1,
                                pagination: true,
                                width: '100%',
                                drag: 'free',
                                snap: true,
                                interval: 5000,
                                noDrag: true,
                                gap: 10,
                                focus: 'center'

                            }}
                        >

                            {fotos.map((item, index) => {
                                return (
                                    <SplideSlide key={`qer${index}`}>
                                        <Box>
                                            <Zoom>
                                                <img src={item} width={'100%'}
                                                     height={'auto'}
                                                     style={{borderRadius: 16}}/>
                                            </Zoom>
                                        </Box>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>
                        :

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={2}
                        >

                            {fotos.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 3}}>
                                        <Box>
                                            <Zoom>
                                                <img src={it} width={'100%'}
                                                     height={'auto'}
                                                     style={{borderRadius: 16}}/>
                                            </Zoom>
                                        </Box>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    }


                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Producto_Match
